<template>
  <div>
    <basic-container>
      <avue-crud
        :option="tableOption"
        :data="tableData"
        :table-loading="tableLoading"
        :page="page"
        ref="crud"
        @search-change="searchChange"
        @refresh-change="refreshChange(page)"
        @row-save="handleSave"
        @search-reset="searchClear"
        @row-update="handleUpdate"
        @size-change="pageSizeChange"
        @current-change="pageChange"
      >
        <template slot="searchMenu">
          <!-- <el-button
            size="small"
            class="el-icon-delete"
            @click="searchClear"
            style="width: 80px;left: -88px;position: relative;"
          >清空</el-button>-->
        </template>
        <template slot="search"></template>
        <template
          slot-scope="scope"
          slot="menuLeft"
        >
          <el-button
            type="success"
            icon="el-icon-check"
            size="small"
            plain
            @click.stop="handleAgree()"
          >批量同意退货</el-button>
          <el-button
            type="primary"
            icon="el-icon-printer"
            size="small"
            plain
            @click.stop="printJson()"
          >打印</el-button>
          <el-button
            type="primary"
            icon="el-icon-download"
            size="small"
            plain
            @click.stop="downloadExcelRefun"
          >下载Excel</el-button>
        </template>
        <template
          slot-scope="scope"
          slot="menu"
        >
          <el-button
            type="primary"
            size="small"
            plain
            v-if="scope.row.status =='WAIT_AUDIT'"
            @click.stop="refuseToReturn(scope.row)"
          >退回</el-button>
          <el-button
            type="primary"
            size="small"
            plain
            v-if="scope.row.status =='WAIT_AUDIT'"
            @click.stop="handleAgreeToReturn(scope.row)"
          >同意退货</el-button>
          <el-button
            type="success"
            size="small"
            plain
            v-if="true"
            @click.stop="serviceListing(scope.row)"
          >查看</el-button>
        </template>
      </avue-crud>
      <el-dialog
        :visible.sync="reasonDialog"
        title="拒绝理由"
        center
        width="300px"
      >
        <div style="display: flex;">
          <el-input
            type="textarea"
            :rows="4"
            placeholder="请输入拒绝理由"
            v-model="refuseReason"
          ></el-input>
        </div>
        <div class="typeButton">
          <el-button
            round
            size="mini"
            @click="reasonDialog = false"
          >&nbsp;&nbsp;&nbsp;取消&nbsp;&nbsp;&nbsp;</el-button>
          <el-button
            round
            type="danger"
            size="mini"
            @click="typeEditOk"
          >&nbsp;&nbsp;&nbsp;确定&nbsp;&nbsp;&nbsp;</el-button>
        </div>
      </el-dialog>
      <!-- <el-dialog :visible.sync="payTypeDialog" title="支付方式" center width="300px">
        <div style="display: flex;">
          <div>
            <el-radio v-model="payType" label="WX_PAY">微信支付</el-radio>
            <el-radio v-model="payType" label="BALANCE">余额支付</el-radio>
          </div>
        </div>
        <div class="typeButton">
          <el-button
            round
            size="mini"
            @click="payTypeDialog = false"
          >&nbsp;&nbsp;&nbsp;取消&nbsp;&nbsp;&nbsp;</el-button>
          <el-button
            round
            type="success"
            size="mini"
            @click="typePayOk"
          >&nbsp;&nbsp;&nbsp;确定&nbsp;&nbsp;&nbsp;</el-button>
        </div>
      </el-dialog>-->
    </basic-container>

    <el-dialog
      :visible.sync="refundDialog"
      :before-close="beforeClose"
      done
      center
      width="1000px"
      v-if="isOpen"
    >
      <div class="stockwrap">
        <!--startprint-->
        <div
          v-bind="stockData"
          class="stockMain"
          id="printBox"
        >
          <h1
            class="stockMain title"
            id="printTitle"
          >采购退货单</h1>
          <div
            v-if="isPrint"
            id="printTime"
          >
            <div>{{"打印时间："+handleFormatterDateToUTC(new Date().getTime()) }}</div>
            <div>{{this.companyName}}</div>
          </div>
          <div
            class="stockMain content"
            id="content"
          >
            <!-- <ul>
              <li class="titleLi">
                <p class="titleLi d">
                  <b>采购退货单编号</b>:
                  <span>{{stockData.number}}</span>
                </p>
                <p class="titleLi d">
                  <b>采购出库单编号</b>:
                  <span>{{stockData.businessNumber}}</span>
                </p>
                <p class="titleLi d">
                  <b>退货商户名称</b>:
                  <span>{{stockData.shopName}}</span>
                </p>
              </li>
              <li class="titleLi">
                <p class="titleLi d">
                  <b>法人姓名</b>:
                  <span>{{stockData.name}}</span>
                </p>
                <p class="titleLi d">
                  <b>店铺地址</b>:
                  <span>{{(stockData.address)}}</span>
                </p>
                <p class="titleLi d">
                  <b>采购时间</b>:
                  <span>{{handleFormatterDateToUTC(stockData.purchaseTime)}}</span>
                </p>
              </li>
              <li class="titleLi">
                <p class="titleLi d">
                  <b>申请退货时间</b>:
                  <span>{{handleFormatterDateToUTC(stockData.returnTime)}}</span> 元
                </p>
                <p class="titleLi d">
                  <b>退货商品数量共计</b>:
                  <span>{{stockData.returnGoodsAmount}}</span>
                </p>
                <p class="titleLi d">
                  <b>采购订单金额</b>:
                  <span>{{stockData.businessOrderPrice}}元</span>
                </p>
              </li>
              <li v-if="stockData.returnPrice" class="titleLi">
                <p class="titleLi d">
                  <b>退货订单金额</b>:
                  <span>{{stockData.returnPrice}}元</span>
                </p>
                <p class="titleLi d">
                  <b>退货状态</b>:
                  <span>{{stockData.status == 'WAIT_AUDIT' ? '待审核' : (stockData.status == 'RETURNED' ? '已退回' : '已完成')}}</span>
                </p>
                <p class="titleLi d" v-if="stockData.returnTime">
                  <b>退货时间</b>:
                  <span>{{handleFormatterDateToUTC(stockData.returnTime)}}</span>
                </p>
                <p class="titleLi d" v-if="stockData.status == 'RETURNED'">
                  <b>退回时间</b>:
                  <span>{{handleFormatterDateToUTC(stockData.returnTime)}}</span>
                </p>
              </li>
              <li v-if="stockData.status == 'RETURNED'">
                <p class="titleLi d">
                  <b>退回原因</b>:
                  <span>{{stockData.remarks}}</span>
                </p>
              </li>
              <avue-crud
                :option="table1Option"
                :data="table1Data"
                :table-loading="tableLoading"
                ref="crud"
              ></avue-crud>
            </ul>-->
            <table
              border
              style="width:900px"
            >
              <tr>
                <th style="width:300px">采购退货单编号:</th>
                <th style="width:300px;">{{stockData.number}}</th>
                <th style="width:300px">采购出库单编号:</th>
                <th style="width:300px">{{stockData.businessNumber}}</th>
              </tr>
              <tr>
                <th style="width:300px">退货商户名称:</th>
                <th style="width:300px">{{stockData.shopName}}</th>
                <th style="width:300px">法人姓名:</th>
                <th style="width:300px">{{stockData.name}}</th>
              </tr>
              <tr>
                <th style="width:300px">采购时间:</th>
                <th style="width:300px">{{handleFormatterDateToUTC(stockData.purchaseTime)}}</th>
                <th style="width:300px">店铺地址:</th>
                <th style="width:300px">{{stockData.shopAddress}}</th>
              </tr>
              <tr>
                <th style="width:300px">申请退货时间:</th>
                <th style="width:300px">{{handleFormatterDateToUTC(stockData.returnTime)}}</th>
                <th style="width:300px">退货商品数量共计:</th>
                <th style="width:300px">{{stockData.returnGoodsAmount}}</th>
              </tr>
              <tr>
                <th style="width:300px">采购订单金额:</th>
                <th style="width:300px">{{stockData.businessOrderPrice}}元</th>
                <th style="width:300px">退货订单金额:</th>
                <th style="width:300px">{{stockData.returnPrice}}元</th>
              </tr>

              <tr v-if="stockData.status=='WAIT_AUDIT'">
                <th style="width:300px">退货状态:</th>
                <th style="width:300px">{{stockData.status == 'WAIT_AUDIT' ? '待审核' : (stockData.status == 'RETURNED' ? '已退回' : '已完成')}}</th>
                <th style="width:300px"></th>
                <th style="width:300px"></th>
              </tr>
              <tr v-if="stockData.status=='FINISH'">
                <th style="width:300px">退货状态:</th>
                <th style="width:300px">{{stockData.status == 'WAIT_AUDIT' ? '待审核' : (stockData.status == 'RETURNED' ? '已退回' : '已完成')}}</th>
                <th style="width:300px">退货时间:</th>
                <th style="width:300px">{{stockData.handleTime?handleFormatterDateToUTC(stockData.handleTime):stockData.handleTime}}</th>
                <!-- <th
                  style="width:300px"
                  v-if="stockData.remarks"
                >退回原因:</th>
                <th
                  style="width:300px"
                  v-if="stockData.remarks"
                >{{stockData.remarks}}</th>

                <th
                  style="width:300px"
                  v-if="stockData.returnTime"
                >退回时间:</th>
                <th
                  style="width:300px"
                  v-if="stockData.returnTime"
                >{{stockData.returnTime?handleFormatterDateToUTC(stockData.returnTime):stockData.returnTime}}</th>
                <th
                  style="width:300px"
                  v-if="stockData.status == 'RETURNED'"
                ></th>
                <th
                  style="width:300px"
                  v-if="stockData.status == 'RETURNED'"
                ></th> -->
              </tr>
              <tr v-if="stockData.status=='RETURNED'">
                <th style="width:300px">退货状态:</th>
                <th style="width:300px">{{stockData.status == 'WAIT_AUDIT' ? '待审核' : (stockData.status == 'RETURNED' ? '已退回' : '已完成')}}</th>
                <th style="width:300px">退回时间:</th>
                <th style="width:300px">{{stockData.handleTime?handleFormatterDateToUTC(stockData.handleTime):stockData.handleTime}}</th>
              </tr>
              <tr v-if="stockData.status=='RETURNED'">
                <th style="width:300px">退回原因:</th>
                <th style="width:300px">{{stockData.remarks}}</th>
                <th style="width:300px"></th>
                <th style="width:300px"></th>
              </tr>
            </table>
            <avue-crud
              :option="table1Option"
              :data="table1Data"
              :table-loading="tableLoading"
              border
              ref="crud"
              style="width:auto;margin:0;margin-top:15px"
            ></avue-crud>
          </div>

          <div
            class="stockMain btn"
            id="noprint"
          >
            <!-- <el-button @click="doPdf">下载PDF</el-button> -->
            <el-button @click="doPrint">打印 / 另存为PDF</el-button>
            <el-button
              v-if="stockData.status == 'WAIT_AUDIT'"
              @click.stop="refuseToReturn()"
            >退回</el-button>
            <el-button
              v-if="stockData.status == 'WAIT_AUDIT'"
              @click.stop="handleAgreeToReturn()"
            >同意退货</el-button>
            <!-- <el-button
              v-if="stockData.status == 'WAIT_RECEIV' || stockData.status == 'WAIT_PAY_MONEY'"
              @click="toArDetail"
            >查看应收款</el-button>-->
          </div>
        </div>

        <!--endprint-->
        <!-- <el-dialog :visible.sync="reasonDialog" title="拒绝理由" center width="300px">
      <div style="display: flex;">
        <el-input type="textarea" :rows="4" placeholder="请输入拒绝理由" v-model="refuseReason"></el-input>
      </div>
      <div class="typeButton">
        <el-button
          round
          size="mini"
          @click="reasonDialog = false"
        >&nbsp;&nbsp;&nbsp;取消&nbsp;&nbsp;&nbsp;</el-button>
        <el-button
          round
          type="danger"
          size="mini"
          @click="typeEditOk"
        >&nbsp;&nbsp;&nbsp;确定&nbsp;&nbsp;&nbsp;</el-button>
      </div>
        </el-dialog>-->
      </div>
    </el-dialog>
  </div>
</template>

    <script>
import { mapGetters } from "vuex";
import { refundFormOption } from "@/const/salesCloud/refundFormOption";
import { refundListOption } from "@/const/salesCloud/refundListOption";
import {
  invoiceSystemV2Return,
  invoiceSystemV2ReturnDownloadExcel,
  invoiceSystemV2ReturnPass,
  invoiceSystemV2ReturnRefuse,
  invoiceSystemV2ReturnDetail,
  downloadPDF
} from "@/api/salesCloud/refund";
import { getCompany } from "@/util/auth";
import { DIC } from "@/const/dic";
import VueQr from "vue-qr";
import { excelaxios } from "@/util/excelaxios";
import { exportExcel } from "xlsx-oc";
import { formatterDateToUTC, parseStatus } from "@/util/util";
export default {
  name: "refund",
  components: {
    VueQr
  },
  data() {
    return {
      tableOption: refundListOption, //表格设置属性
      table1Option: refundFormOption, //表格设置属性
      tableData: [], //表格的数据
      table1Data: {},
      tablePage: 1,
      reasonDialog: false,
      payTypeDialog: false,
      stockData: {},
      refundDialog: false,
      isOpen: false,
      isPrint: false,
      companyName: "",
      payType: "WX_PAY",
      refuseReason: "",
      tableLoading: false,
      eleDialog: false,
      serviceCategoryId: "",
      serviceItemId: "",
      payTime: {},
      from: {
        text: "text"
      },
      tabelObj: {},
      page: {
        total: 0, //总页数
        currentPage: 1, //当前页数
        pageSize: 10 //每页显示多少条
      },
      grade: {
        box: false,
        check: []
      },
      users: [],
      userType: "JOINS_ENGINEER",
      point: {},
      serviceCategorys: [],
      serviceCategory: {},
      joinsWorkServiceItems: [],
      workOrderStatus: DIC.WORK_ORDER_STATUS,
      QRCodeDialog: false,
      config: {},
      evaluateDialog: false,
      score: 5,
      clues: [],
      evaluateObj: {},
      serviceFee: [],
      propertiesViceList: [],
      downloadData: {}
    };
  },
  created() {
    this.handleList();
  },
  watch: {},
  mounted() {},
  computed: {
    ...mapGetters(["permission"])
  },
  props: [],
  methods: {
    beforeClose(done) {
      this.rowId = "";
      console.log(this.rowId);
      done();
    },
    //转换为标准时间
    handleFormatterDateToUTC(data) {
      return formatterDateToUTC(data);
    },
    handleAgree() {
      console.log("同意退货");
      console.log(this.$refs.crud.tableSelect);
      let ids = this.$refs.crud.tableSelect.map(item => {
        return item.id;
      });
      console.log(ids);
      if (ids == "") {
        this.$message({
          showClose: true,
          message: "请选择要操作数据",
          type: "error"
        });
        return;
      }
      invoiceSystemV2ReturnPass(ids).then(res => {
        this.tableLoading = true;
        if (res.code == "200") {
          this.$message({
            showClose: true,
            message: "批量同意退货成功",
            type: "success"
          });
          this.tableLoading = false;
          this.rowId = "";
          setTimeout(() => {
            this.handleList();
            console.log("延迟刷新");
          }, 1000);
        } else {
          this.$message({
            showClose: true,
            message: res.message,
            type: "error"
          });
          this.handleList();
        }
      });
    },
    refuseToReturn(row) {
      console.log(row);
      this.reasonDialog = true;
      console.log(this.rowId);
      if (row === undefined) {
        this.rowId = this.rowId;
      } else {
        this.rowId = "";
        this.rowId = this.rowId ? this.rowId : row.id;
      }
    },
    typeEditOk() {
      let params = {
        reason: this.refuseReason.replace(/(^\s+)|(^\s+$)/g, "")
      };
      if (this.refuseReason) {
        invoiceSystemV2ReturnRefuse(this.rowId, params).then(res => {
          console.log("退回", res);
          //重置字段
          if (res.code == "200") {
            this.$message({
              showClose: true,
              message: "退回中...",
              type: "error"
            });
            this.handleList();
            this.reasonDialog = false;
            this.rowId = "";
            this.refuseReason = "";
            this.refundDialog = false;
            setTimeout(() => {
              this.$message({
                showClose: true,
                message: "退回成功",
                type: "success"
              });
            }, 1000);
          } else {
            this.$message({
              showClose: true,
              message: "退回中...",
              type: "error"
            });
            setTimeout(() => {
              this.$message({
                showClose: true,
                message: res.message,
                type: "error"
              });
              this.handleList();
            }, 2000);
            this.rowId = "";
            this.reasonDialog = false;
          }
        });
      } else {
        this.$message({
          showClose: true,
          message: "请填写拒绝理由",
          type: "error"
        });
        this.rowId = "";
      }
    },
    handleAgreeToReturn(row) {
      console.log(this.rowId);
      if (row === undefined) {
        this.rowId = this.rowId;
      } else {
        this.rowId = "";
        this.rowId = this.rowId ? this.rowId : row.id;
      }
      this.tableLoading = true;
      invoiceSystemV2ReturnPass(this.rowId).then(res => {
        console.log("同意退货", res);
        if (res.code == "200") {
          this.$message({
            showClose: true,
            message: "同意退货成功",
            type: "success"
          });
          this.rowId = "";
          this.refundDialog = false;
          this.tableLoading = false;
          setTimeout(() => {
            this.handleList();
            console.log("延迟刷新1000");
          }, 1000);
        } else {
          this.$message({
            showClose: true,
            message: res.message,
            type: "error"
          });
          this.rowId = "";
          this.handleList();
        }
      });
    },
    // typePayOk() {
    //   invoiceSystemV2ReturnPass(this.rowId).then(res => {
    //     console.log("同意退货", res);
    //   });
    // },
    pageSizeChange(pageSize) {
      this.tableLoading = true;
      let params = this.$refs.crud.searchForm;
      params.page = this.page.currentPage;
      params.size = pageSize;
      this.downloadData = params;
      console.log(params);
      invoiceSystemV2Return(params).then(res => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: this.page.currentPage,
          pageSize: pageSize
        };
        this.tableLoading = false;
      });
    },
    pageChange(page) {
      this.tableLoading = true;
      let params = this.$refs.crud.searchForm;
      params.page = page;
      params.size = this.page.pageSize;
      this.downloadData = params;
      invoiceSystemV2Return(params).then(res => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: page,
          pageSize: this.page.pageSize
        };
        this.tableLoading = false;
      });
    },
    searchClear() {
      // this.$refs.crud.$refs.searchForm.resetFields();
      this.serviceCategory = "";
      this.serviceCategoryId = "";
      this.serviceItem = "";
      this.serviceItemId = "";
      console.log(this);
    },
    searchChange(params) {
      this.tableLoading = true;
      // let params = this.$refs.crud.searchForm
      params.page = this.page.currentPage;
      params.size = this.page.pageSize;
      if (
        null != params.startDate_endDate &&
        undefined != params.startDate_endDate &&
        "" != params.startDate_endDate
      ) {
        params.startTime = params.startDate_endDate[0];
        params.endTime = params.startDate_endDate[1];
      } else {
        params.startTime = "";
        params.endTime = "";
      }
      this.downloadData = params;
      console.log(params);
      invoiceSystemV2Return(params).then(res => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: params.page,
          pageSize: params.size
        };
        this.tableLoading = false;
      });
    },
    refreshChange(page) {
      this.tableLoading = true;
      let params = this.$refs.crud.searchForm;
      params.page = page.currentPage;
      params.size = page.pageSize;
      this.downloadData = params;
      invoiceSystemV2Return(params).then(res => {
        let data = JSON.parse(res.data);
        console.log(data.rows[0].id);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: page.currentPage,
          pageSize: page.pageSize
        };
        this.tableLoading = false;
      });
    },

    handleDetail(row, index) {},
    /**
     * @title 打开新增窗口
     * @detail 调用crud的handleadd方法即可
     *
     **/
    handleAdd() {
      this.point = {};
      this.serviceCategory = {};
      this.joinsWorkServiceItems = [];
      this.$refs.crud.rowAdd();
    },
    /**
     * @title 获取数据
     * @detail 赋值为tableData表格即可
     *
     **/
    handleList() {
      this.tableLoading = true;
      let params = {
        page: this.page.currentPage,
        size: this.page.pageSize
      };
      this.downloadData = params;
      invoiceSystemV2Return(params).then(res => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: this.page.currentPage,
          pageSize: this.page.pageSize
        };
        this.tableLoading = false;
      });
    },
    /**
     * @title 数据添加
     * @param row 为当前的数据
     * @param done 为表单关闭函数
     *
     **/
    handleSave() {},
    /**
     * @title 数据更新
     * @param row 为当前的数据
     * @param index 为当前更新数据的行数
     * @param done 为表单关闭函数
     *
     **/
    handleUpdate() {},

    serviceListing(row) {
      console.log(row);
      this.refundDialog = true;
      this.rowId = row.id;
      console.log(this.rowId);
      invoiceSystemV2ReturnDetail(this.rowId).then(res => {
        let data = JSON.parse(res.data);
        console.log(res);
        this.stockData = data;
        this.isOpen = true;
        this.table1Data = data.goods;
        this.tableLoading = false;
      });
      // this.$router.push({
      //   name: "采购退货单",
      //   params: { id: row.id }
      // });
    },
    formmaterImage(row) {
      let str = new Array();
      console.log("row：" + JSON.stringify(row));
      if (row != null) {
        let picArray = row.split(",");
        for (let i = 0; i < picArray.length; i++) {
          // console.log("url："+ row[i].url)
          str.push(picArray[i]);
        }
      }
      return str;
    },
    downloadExcelRefun() {
      let params = this.downloadData;
      invoiceSystemV2ReturnDownloadExcel(params).then(res => {
        window.open(res);
      });
    },
    doPdf() {
      downloadPDF(this.rowId);
      console.log("111");
    },
    doPrint() {
      this.isPrint = true;
      this.companyName = getCompany();
      this.$nextTick(() => {
        var printBox = document.getElementById("printBox");
        //拿到打印的区域的html内容
        var newContent = printBox.innerHTML;
        //将旧的页面储存起来，当打印完成后返给给页面。
        var oldContent = document.body.innerHTML;
        //赋值给body
        document.body.innerHTML = newContent;
        //执行window.print打印功能
        window.print();
        // 重新加载页面，以刷新数据。以防打印完之后，页面不能操作的问题
        document.body.innerHTML = oldContent;
        window.location.reload(false);
        return false;
      });
    },
    printJson() {
      this.tableLoading = true;
      let params = this.$refs.crud.searchForm;
      params.page = this.page.currentPage;
      params.size = this.page.pageSize;
      this.downloadData = params;
      invoiceSystemV2Return(params).then(res => {
        let data = JSON.parse(res.data);
        let someJSONdata = data.rows;
        someJSONdata = someJSONdata.map(item => {
          item.purchaseTime = formatterDateToUTC(item.purchaseTime);
          item.returnTime = formatterDateToUTC(item.returnTime);
          item.remarks = item.remarks ? item.remarks : "";
          if (item.status == "WAIT_PAY") {
            item.status = "待付款";
          } else if (item.status == "WAIT_OUT") {
            item.status = "待出库";
          } else if (item.status == "WAIT_CONFIRM") {
            item.status = "待收货";
          } else if (item.status == "RETURNED") {
            item.status = "已退回";
          } else if (item.status == "FINISH") {
            item.status = "已完成";
          } else if (item.status == "INVALID") {
            item.status = "已失效";
          } else if (item.status == "CANCELED") {
            item.status = "已取消";
          } else if (item.status == "WAIT_REFUND") {
            item.status = "待退款";
          } else {
            item.status = "error" + item.status;
          }
          return item;
        });
        this.tableLoading = false;
        let s = formatterDateToUTC(new Date().getTime());
        let c = getCompany();
        printJS({
          printable: someJSONdata,
          header: `<div style='position:absolute;bottom:0;display:flex;flex-flow: row nowrap;width:100%; justify-content: space-between;'><div>打印时间：${s}</div><div style="margin-right:15px;">${c}</div></div>`,
          properties: [
            { field: "number", displayName: "采购退货编号" },
            { field: "businessNumber", displayName: "采购出库单编号" },
            { field: "account", displayName: "账号" },
            { field: "shopName", displayName: "店铺名称" },
            { field: "name", displayName: "法人名称" },
            { field: "businessOrderPrice", displayName: "采购金额" },
            { field: "purchaseTime", displayName: "采购时间" },
            { field: "status", displayName: "退货状态" },
            { field: "returnTime", displayName: "申请退货时间" },
            { field: "returnPrice", displayName: "退货金额" },
            { field: "remarks", displayName: "退回原因" }
          ],
          targetStyles: "width:200px",
          gridHeaderStyle:
            "border: 1px solid  lightgray;white-space:nowrap;padding:0px 8px;text-align:center ",
          gridStyle:
            "border: 1px solid lightgray;white-space:nowrap;padding:8px 10px ;text-align:center",
          type: "json"
        });
      });
    }
  }
};
</script>

<style scoped lang="scss">
#print {
  // display: block;
}
.table-container {
  padding: 8px 10px;
}

.demo-table-expand {
  font-size: 0;
}

.demo-table-expand label {
  width: 90px;
  color: #99a9bf;
}
.typeButton {
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  align-items: center;
  margin-top: 50px;
}
.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 50%;
}

.typeButton {
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  align-items: center;
  margin-top: 50px;
}
.stockwrap {
  background: #fff;
  margin: 1px 10px;
  padding-bottom: 100px !important;
  height: auto;
  display: flex;
  align-items: center;
  justify-content: center;
}
.stockMain {
  // border: 1px solid #606266;
  display: flex;
  width: 100%;
  flex-flow: column wrap;
  justify-content: center;
  align-items: flex-start;
  margin: 1px 20px;
  font-size: 14px;
  color: #333;
  .content {
    border: none;
    ul {
      .titleLi {
        display: flex;
        justify-content: flex-start;
      }
      .titleLi .d {
        width: 300px;
        span {
          margin-right: 10px;
        }
      }
    }
  }
  .title {
    position: relative;
    left: 50%;
    border: none;
    font-weight: Medium;
    font-size: 22px;
    margin-bottom: 30px;
    color: #333;
    margin-left: -37px;
  }
  .btn {
    position: absolute;
    bottom: 20px;
    left: 0;
    border: none;
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    button {
      margin: 0 20px;
    }
  }
}
.avue-crud {
  margin-right: 0;
  margin: 0;
}
</style>

<style lang="scss">
@media print {
  #printTime {
    width: 100%;
    position: absolute;
    bottom: 0;
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-between;
  }
  #print {
    display: block;
  }
  #printBox {
    position: relative;
    left: 0;
  }
  .el-table td,
  .el-table th.is-leaf {
    border-bottom: 1px solid #333;
  }
  .el-table--border td,
  .el-table--border th {
    border-right: 1px solid #333;
  }
  .el-table th {
    // border-top: 1px solid #333;
  }
  .el-table--border,
  .el-table--group {
    border: 1px solid #333;
  }
  .el-table--enable-row-transition {
    border: 1px solid #333;
  }

  #printTitle {
    position: relative;
    border: none;
    left: 50%;
    font-weight: Medium;
    font-size: 22px;
    margin-bottom: 30px;
    color: #333;
    margin-left: -37px;
  }
  #noprint {
    display: none;
  }
  .avue-crud {
    margin-right: 0;
    margin: 0;
    width: 900px;
  }
  #content {
    color: #333;
    border: none;
    margin-left: 6%;
    ul {
      .titleLi {
        display: flex;
        justify-content: flex-start;
      }
      .titleLi span {
        margin-left: 10px;
        color: #333;
      }
      .titleLi .d {
        width: 345px;
      }
    }
  }
}
</style>